/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { useState } from 'react';
import { Box, Button, DialogActions, Typography } from '@mui/material';
import DialogContainer from '../../../../../components/shared/Dialog/DialogContainer';
import { toast } from 'react-toastify';
import { revokeAssetLocationUser } from '../../../../../services/assetLocation/assetLocationController';

const AssetLocationRevokeUser = ({userName}) => {
    const [open, setOpen] = useState(false);

    // Handle open/close dialog
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);



    // Handle form submission
    const handleSubmit = async (values) => {


        try {
            // if your API expects an object, wrap it:
            const values = { userName };
            await revokeAssetLocationUser({ username: userName });
            console.log('submitted values:', values);
            toast.success(`User "${userName}" was revoked successfully`);
        } catch (error) {
            toast.error(error?.response?.data?.error?.message || 'Revoke failed');
        } finally {
            handleClose();
        }

    };
    return (
        <>
            <Button variant="outlined" color="error" style={{ float: 'right' }} onClick={handleOpen}>Revoke</Button>
            {/* Dialog for Adding MApping */}
            <DialogContainer open={open} handleClose={handleClose}>
                <Box sx={{ mt: 1 }}>
                    <Typography variant="h3" align="center" gutterBottom>
                        Confirm Revoke
                    </Typography>
                    <Typography align="center" variant="h3" sx={{ mb: 3 }}>
                        Are you sure you want to revoke user <strong>{userName}</strong>?
                    </Typography>

                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={handleSubmit}
                        >
                            Confirm
                        </Button>
                    </DialogActions>
                </Box>
            </DialogContainer>
        </>
    )

}

export default AssetLocationRevokeUser;
